module.exports = __webpack_public_path__ + "img/cardimg.0b4787b0.png";